import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed, PropType } from "vue";
import { ValidationStateType } from "@/types/Validation";

type Option = Record<string, string | number | null>;


export default /*#__PURE__*/_defineComponent({
  __name: 'AppFormSelect',
  props: {
  value: {
    validator: prop =>
      typeof prop === "string" || typeof prop === "number" || prop === null,
    required: true
  },
  formOptions: {
    type: Array as PropType<Option[]>,
    required: true
  },
  textField: {
    type: String,
    default: "text"
  },
  valueField: {
    type: String,
    default: "value"
  },
  disabled: {
    type: Boolean,
    default: false
  },
  firstOption: {
    type: String,
    default: "項目を選択して下さい"
  },
  validationState: {
    type: Object as PropType<ValidationStateType>
  },
  selectedOptions: {
    type: Array as PropType<Option[]>,
    default: () => []
  },
  excludeSelected: {
    type: Boolean,
    default: false
  }
},
  emits: ["input", "change", "mousedown"],
  setup(__props, { emit: emits }) {

const props = __props;



const isInvalid = computed(() => {
  return (
    props.validationState?.errors && props.validationState?.errors.length > 0
  );
});

const displayFormOptions = computed(() => {
  if (!props.excludeSelected) {
    return props.formOptions;
  }
  return props.formOptions.filter(option => {
    return !props.selectedOptions
      .filter(item => item[props.valueField] !== props.value)
      .some(item => item[props.valueField] === option[props.valueField]);
  });
});

const selectedOption = computed({
  get() {
    return props.value;
  },
  set(newVal) {
    if (props.value !== newVal) emits("input", newVal);
  }
});



function onChange(v: string) {
  emits("change", v);
}

function onMouseDown() {
  emits("mousedown");
}

return (_ctx: any,_cache: any) => {
  const _component_BFormSelectOption = _resolveComponent("BFormSelectOption")!
  const _component_BFormSelect = _resolveComponent("BFormSelect")!

  return (_openBlock(), _createElementBlock("div", {
    class: "select-wrapper",
    onMousedown: onMouseDown
  }, [
    _createVNode(_component_BFormSelect, {
      class: _normalizeClass(["app-select", {
        'text-gray-04': __props.value === null,
        'is-invalid': isInvalid.value
      }]),
      modelValue: selectedOption.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedOption).value = $event)),
      options: displayFormOptions.value,
      "text-field": __props.textField,
      "value-field": __props.valueField,
      disabled: __props.disabled,
      onChange: onChange
    }, {
      first: _withCtx(() => [
        _createVNode(_component_BFormSelectOption, {
          value: null,
          disabled: ""
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(__props.firstOption), 1)
          ], undefined, true),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["class", "modelValue", "options", "text-field", "value-field", "disabled"])
  ], 32))
}
}

})